<template>
  <v-menu
    v-model="show"
    :close-on-content-click="false"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <span class="caption grey--text text--darken-1">{{label}}</span>
      <v-text-field
        :value="displayValue"
        @click:clear="onInput('')"
        clearable
        readonly
        required
        solo
        v-on="on"
        class="thin-border"
      >
        <template slot="prepend-inner">
          <Icon name="calendare" />
        </template>
      </v-text-field>
    </template>
    <v-date-picker :max="max" clearable :value="isoValue" @input="onInput" />
  </v-menu>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number]
    },
    max: {
      type: String,
      required: false
    },
    label: {
      type: String,
      default: ''
    },
    initialDate: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      actualDate: new Date().toISOString().substring(0, 10),
      show: false
    }
  },
  computed: {
    isoValue() {
      const date = this.actualDate ? new Date(this.actualDate) : undefined
      if (!date) return undefined
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    displayValue() {
      if (!this.actualDate) return ''
      return new Date(this.actualDate).toLocaleDateString(undefined, {
        timeZone: 'UTC'
      })
    }
  },
  methods: {
    onInput(val) {
      const epoch = val ? new Date(val).getTime() : undefined
      this.show = false
      this.$emit('input', epoch)
      this.actualDate = epoch ? new Date(epoch) : ''
    }
  },
  created: function() {
    if (this.initialDate) {
      this.actualDate = this.value
        ? new Date(this.value)
        : new Date(this.actualDate)
      this.onInput(this.actualDate)
    } else {
      this.actualDate = this.value ? new Date(this.value) : null
    }
  }
}
</script>

<style></style>
